import { Button, LinkButton } from '@cian/ui-kit';
import * as React from 'react';
import { connect } from 'react-redux';

import styles from './index.css';
import { trackingPhoneEvent } from '../../../store/tracking/mobile';
import { IBuilderSchema } from '../../../types';
import { TTypedThunkDispatch } from '../../../types/store';
import { formatRawPhone } from '../../../utils/formatRawPhone';
import { formatPhone } from '../../../utils/helpers';
import { isStickySupported } from '../../../utils/is_sticky_supported';
import { shouldBeFixed } from '../../../utils/shouldBeFixed';
import { makeFixedComponent, INoFixedProps, IFixedProps, FixedContainer } from '../../common/fixed_component';
import { BuilderLayoutContainer } from '../builder_layout/container';
import { PopupMobile } from '../popup_mobile';

const TEN_SECONDS = 10000;

interface IContactButtonDispatchProps {
  trackingShowPhone(): void;
  trackingCallPhone(): void;
}

interface IContactButtonOwnProps {
  phone: string;
}

type TContactButtonProps = IContactButtonOwnProps & IContactButtonDispatchProps;

export class ContactButton extends React.PureComponent<TContactButtonProps> {
  public componentDidMount() {
    window.addEventListener('blur', this.windowOnBlur);
    window.addEventListener('focus', this.windowOnFocus);
  }
  public componentWillUnmount() {
    window.removeEventListener('blur', this.windowOnBlur);
    window.removeEventListener('focus', this.windowOnFocus);
  }

  public render() {
    const { phone } = this.props;

    return (
      <div className={styles['contact_button']}>
        <div className={styles['call']}>
          <div className={styles['sticky_button']}>
            <LinkButton
              href={`tel:${formatRawPhone(phone)}`}
              size="M"
              fullWidth={true}
              onClick={this.handlerCallButtonClick}
            >
              Позвонить
            </LinkButton>
          </div>
        </div>
        <span className={styles['show']}>
          <PopupMobile
            animation="toggle-bottom"
            onOpen={this.props.trackingShowPhone}
            popupContent={({ onClose }) => (
              <div className={styles['popup']}>
                <BuilderLayoutContainer isInjected />
                <LinkButton
                  href={`tel:${formatRawPhone(phone)}`}
                  size="M"
                  fullWidth={true}
                  theme="stroke_primary"
                  onClick={this.handlerCallButtonClick}
                >
                  {formatPhone(phone)}
                </LinkButton>
                <div onClick={onClose} className={styles['close']}>
                  Закрыть
                </div>
              </div>
            )}
          >
            <div className={styles['sticky_button']}>
              <Button size="M" fullWidth={true}>
                Показать контакты застройщика
              </Button>
            </div>
          </PopupMobile>
        </span>
      </div>
    );
  }

  private windowIsNonActive = false;

  private windowOnBlur = () => {
    this.windowIsNonActive = true;
  };

  private windowOnFocus = () => {
    this.windowIsNonActive = false;
  };

  private handlerCallButtonClick = () => {
    this.props.trackingShowPhone();
    setTimeout(() => {
      if (this.windowIsNonActive) {
        this.props.trackingCallPhone();
      }
    }, TEN_SECONDS);
  };
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch): IContactButtonDispatchProps {
  return {
    trackingShowPhone() {
      dispatch(trackingPhoneEvent('Open_KP_card'));
    },
    trackingCallPhone() {
      dispatch(trackingPhoneEvent('Call_KP_card'));
    },
  };
}

export const ContactButtonContainer = connect<null, IContactButtonDispatchProps>(
  null,
  mapDispatchToProps,
)(ContactButton);

export const FixedButton: React.FC<IFixedProps & IContactButtonOwnProps> = props => {
  return (
    <div className={styles['fixed_container']}>
      <ContactButtonContainer {...props} />
    </div>
  );
};

export const NoFixedButton: React.FC<INoFixedProps & IContactButtonOwnProps> = ({ hidden, ...props }) => {
  return hidden ? <div className={styles['button--hidden']} /> : <ContactButtonContainer {...props} />;
};

export interface IShowContactsLayoutStateProps {
  phone: IBuilderSchema['phone'];
}

type TShowContactsLayoutProps = IShowContactsLayoutStateProps;

export class ShowContactsLayout extends React.Component<TShowContactsLayoutProps> {
  private isStickyAvailable = true;

  public componentDidMount() {
    this.isStickyAvailable = isStickySupported();
  }
  public render() {
    const { phone } = this.props;

    if (!phone) {
      return null;
    }

    if (this.isStickyAvailable) {
      return <ContactButtonContainer phone={phone} />;
    } else {
      const FixedComponent = makeFixedComponent({
        id: 'ShowContacts',
        Fixed: FixedButton,
        NoFixed: NoFixedButton,
        shouldBeFixed: shouldBeFixed(62),
      });

      return (
        <div className={styles['wrapper_fixed_container']}>
          <FixedContainer name="ShowContacts" />
          <FixedComponent container="ShowContacts" phone={phone} />
        </div>
      );
    }
  }
}
